import { Controller } from "stimulus"

import EditorUI from '../src/editor/editor_ui';

export default class extends Controller {
  fullUrl() {
    return `${this.data.get("url")}/full_image`;
  }

  showDownloadDialog(e) {
    e.preventDefault()
    $.magnificPopup.open({
      items: {
        src: this.fullUrl()
      },
      type: 'ajax'
    });
  }

  edit(e) {
    e.preventDefault();

    var target = $(e.target);
    if(!target.is(".btn")) target = target.closest(".btn");

    EditorUI.show({
      "foreground-url": target.data("foreground-url"),
      "original-url": target.data("original-url"),
      "filename": target.data("filename"),
      "foregroundType": target.data("foreground-type"),
      "locale": document.documentElement.lang,
    });
  }
}
